import { defineMessages } from 'react-intl';

/** The Support tab (design settings-redesign d1-d5). */
export const supportMessages = defineMessages({
  subtitle: {
    id: 'app.sml.settings.support.subtitle',
    defaultMessage: 'Find an answer in the help center, or write to us. A person reads every message.',
  },
  helpCenterDescription: {
    id: 'app.sml.settings.support.helpCenter.description',
    defaultMessage: 'Guides for every part of MUSIC24.',
  },
  openHelpCenter: { id: 'app.sml.settings.support.helpCenter.open', defaultMessage: 'Open the help center' },
  commonQuestions: { id: 'app.sml.settings.support.commonQuestions', defaultMessage: 'Common questions' },
  topicNoCode: { id: 'app.sml.settings.support.topic.noCode', defaultMessage: 'I did not get a sign-in code' },
  topicPayment: { id: 'app.sml.settings.support.topic.payment', defaultMessage: 'A payment or plan problem' },
  topicPostFailed: { id: 'app.sml.settings.support.topic.postFailed', defaultMessage: 'A post failed to publish' },
  topicDataStale: { id: 'app.sml.settings.support.topic.dataStale', defaultMessage: 'My data is not updating' },
  topicSmartLink: { id: 'app.sml.settings.support.topic.smartLink', defaultMessage: 'A SmartLink does not work' },
  topicCancel: { id: 'app.sml.settings.support.topic.cancel', defaultMessage: 'Cancel your plan' },
  formTitle: { id: 'app.sml.settings.support.form.title', defaultMessage: 'Write to us' },
  replyTo: { id: 'app.sml.settings.support.form.replyTo', defaultMessage: 'We reply to {email}.' },
  messageLabel: { id: 'app.sml.settings.support.form.label', defaultMessage: 'Your message' },
  messagePlaceholder: {
    id: 'app.sml.settings.support.form.placeholder',
    defaultMessage: 'What happened, and on which page?',
  },
  send: { id: 'app.sml.settings.support.form.send', defaultMessage: 'Send' },
  sending: { id: 'app.sml.settings.support.form.sending', defaultMessage: 'Sending' },
  orEmail: { id: 'app.sml.settings.support.form.orEmail', defaultMessage: 'Or email {email}' },
  sentTitle: {
    id: 'app.sml.settings.support.form.sent.title',
    defaultMessage: 'Thank you. Your message is on its way.',
  },
  sentBody: {
    id: 'app.sml.settings.support.form.sent.body',
    defaultMessage: 'We reply to {email}, usually within one working day.',
  },
  writeAnother: { id: 'app.sml.settings.support.form.another', defaultMessage: 'Write another message' },
  failed: {
    id: 'app.sml.settings.support.form.failed',
    defaultMessage: 'We could not send that. Try again, or email {email}.',
  },
  detailsTitle: { id: 'app.sml.settings.support.details.title', defaultMessage: 'Details we attach' },
  detailsDescription: {
    id: 'app.sml.settings.support.details.description',
    defaultMessage: 'They go with your message, so we can find your account.',
  },
  signedInAs: { id: 'app.sml.settings.support.details.signedInAs', defaultMessage: 'Signed in as' },
  workspace: { id: 'app.sml.settings.support.details.workspace', defaultMessage: 'Workspace' },
  appVersion: { id: 'app.sml.settings.support.details.appVersion', defaultMessage: 'App version' },
  deviceId: { id: 'app.sml.settings.support.details.deviceId', defaultMessage: 'Device ID' },
  copy: { id: 'app.sml.settings.support.details.copy', defaultMessage: 'Copy details' },
  copied: { id: 'app.sml.settings.support.details.copied', defaultMessage: 'Copied' },
});
